<template>
    <section class="tile flex flex-col gap-4 overflow-hidden bg-white lg:gap-6">
        <header class="flex flex-col gap-4">
            <h2 v-if="title" class="order-2 text-3xl">{{ title }}</h2>
            <h3 v-if="subTitle" class="font-body order-1">{{ subTitle }}</h3>
        </header>

        <!-- Desktop view: grid layout -->
        <div class="hidden gap-6 lg:grid lg:grid-cols-6">
            <TeamCard v-for="(item, index) in items" :key="`team-grid-${index}`" v-bind="item" />
        </div>

        <!-- Mobile view: carousel -->
        <ClientOnly>
            <div class="carousel-wrapper relative -mx-4 w-screen lg:hidden">
                <swiper
                    :breakpoints="{
                        640: { slidesPerView: 2.2, spaceBetween: 16 },
                    }"
                    class="team-carousel"
                    :slides-per-view="1.2"
                    :space-between="16">
                    <swiper-slide
                        v-for="(item, index) in items"
                        :key="`team-carousel-${index}`"
                        class="swiper-slide">
                        <TeamCard v-bind="item" />
                    </swiper-slide>
                </swiper>
            </div>
        </ClientOnly>
    </section>
</template>

<script lang="ts" setup>
import type { TeamComponentModel } from '@su4r-frontend/api';
import { Swiper, SwiperSlide } from 'swiper/vue';

defineProps<TeamComponentModel>();
</script>

<style lang="css">
@import 'swiper/css';

.carousel-wrapper {
    margin-left: calc(-1 * var(--tile-padding, 1rem));
    margin-right: calc(-1 * var(--tile-padding, 1rem));
    overflow: hidden;
    box-sizing: border-box;
}

.team-carousel {
    padding-left: var(--tile-padding, 1rem);
    width: 100%;
}

/* Responsive adjustments */
@media (width >= 640px) {
    .carousel-wrapper {
        margin-left: calc(-1 * var(--tile-padding-md, 1.5rem));
        margin-right: calc(-1 * var(--tile-padding-md, 1.5rem));
    }

    .team-carousel {
        padding-left: var(--tile-padding-md, 1.5rem);
    }
}
</style>
